// utils/API/BackendHelper/COLLEGES/student.js

import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class CollegeCourseHelper {
  /**
   * Fetch all students for the COLLEGES
   * @param {Object} params - Query parameters (page, limit, search, etc.)
   * @returns {Promise} API response
   */
  async getAllCourses(params = {}) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.COLLEGES.ALL_COURSES, params);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch courses: ${error.message}`);
    }
  }

    /**
     * Fetch details of courses bought by the college
     * @param {string} collegeId - ID of the college
     * @returns {Promise} API response      
     **/

    async getPurchasedCourses() {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.COLLEGES.PURCHASED_COURSES);
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch purchased courses: ${error.message}`);
        }
    }
    
    async getStudentEnrollmentStats() {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.COLLEGES.STUDENT_ENROLLMENT_STATS);
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch student enrollment stats: ${error.message}`);
        }

    }

}

export default new CollegeCourseHelper();